import { useTranslation } from 'react-i18next';

interface TopNavigationProps {
  title: string;
  showBack?: boolean;
  onBack?: () => void;
  rightAction?: React.ReactNode;
}

export default function TopNavigation({ title, showBack, onBack, rightAction }: TopNavigationProps) {
  const { t } = useTranslation();

  return (
    <div className="fixed top-0 left-0 right-0 bg-[#5B9BD5] text-white px-4 py-3 z-50 flex items-center justify-between">
      <div className="flex items-center">
        {showBack && (
          <button onClick={onBack} className="mr-3">
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        )}
        <h1 className="text-lg font-bold">{title}</h1>
      </div>
      {rightAction && (
        <div>{rightAction}</div>
      )}
    </div>
  );
}